var map = {
	"./0.png": "y7RT",
	"./1.png": "+6ZX",
	"./10.png": "RXXv",
	"./11.png": "Gr1j",
	"./2.png": "pS4P",
	"./3.png": "atZv",
	"./4.png": "q0cP",
	"./5.png": "QEKm",
	"./6.png": "0RBE",
	"./7.png": "06o3",
	"./8.png": "3mPC",
	"./9.png": "nD7J"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CDVH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww_new ^\.\/.*\.png$
// module id = CDVH
// module chunks = 0